<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    @on-confirm="advsearch"
    @on-cancel="onCancel()"
    :okText="$t('Search')"
    :closeText="$t('Close')"
    maxWidth="60%"
  >
    <v-row>
      <v-col cols="12" sm="auto" align-self="center">
        <base-multiselect
          :ref="contentTypesMultiselectKey"
          :items="userContentTypes"
          @on-selection-change="onContentTypeSelected"
          prependIcon="mdi-folder-open-outline"
        />
      </v-col>
      <v-col cols="12" sm="auto" align-self="center">
        <v-switch
          v-model="userSearch.searchAllVersions"
          :label="$t('SearchInAllVersions')"
        ></v-switch>
      </v-col>
      <v-col cols="12" sm="auto" align-self="center" class="ml-auto">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text small color="error" @click="clear">
              <v-icon large>mdi-eraser</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Clear") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <SearchCriteriaBuilder
      :ref="searchCriteriaBuilderKey"
      :contentTypeIDs="userSearch.contentTypeIDs"
    />
    <UserSearchModal :ref="userSearchModalKey" />
    <template v-slot:actions>
      <div style="position: absolute">
        <v-menu bottom right v-if="userSavedSearches.length > 0">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip top>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  text
                  small
                  v-bind="attrs"
                  v-on="{ ...tooltip, ...menu }"
                  color="warning"
                >
                  <v-icon large>mdi-database-edit</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, i) in userSavedSearches"
              :key="i"
              @click="onSearchEdit(item)"
            >
              <v-list-item-title>{{ item.FilterName }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text small color="success" @click="onSearchSave">
              <v-icon large>mdi-content-save</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Save") }}</span>
        </v-tooltip>
        <v-tooltip top v-if="showDelete">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text small color="error" @click="onSearchDelete">
              <v-icon large>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Delete") }}</span>
        </v-tooltip>
      </div>
    </template>
  </base-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import SearchType from "@/ecm/variables/SearchType";
import SearchCriteriaBuilder from "@/components/search/SearchCriteriaBuilder.vue";
import UserSearchModal from "@/components/search/advSearch/UserSearchModal.vue";
import UserSearch from "@/ecm/models/UserSearch";
import SearchService from "@/services/SearchService";
import Utils from "@/ecm/common/Utils.js";

export default {
  name: "AdvSearchModal",
  components: {
    SearchCriteriaBuilder,
    UserSearchModal,
  },
  props: {
    documentId: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.userSearch = new UserSearch();
    this.userSearch.contentTypeIDs = this.userContentTypes.map((x) => x.id);
  },
  data() {
    return {
      modal: {
        title: this.$t("AdvancedSearch"),
        key: "advSearchModal",
      },
      contentTypesMultiselectKey: "ctAdvSearchMultiselectKey",
      searchCriteriaBuilderKey: "searchCriteriaBuilderKey",
      userSearchModalKey: "userSearchModalKey",
      userSearch: new UserSearch(),
      open: false,
    };
  },
  mixins: [validationMixin],
  validations: {},
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    modalTitle() {
      return (
        this.modal.title +
        (this.userSearch.name ? ` - ${this.userSearch.name}` : "")
      );
    },
    contentTypesMultiselectInstance() {
      return this.$refs[this.contentTypesMultiselectKey];
    },
    searchCriteriaBuilderInstance() {
      return this.$refs[this.searchCriteriaBuilderKey];
    },
    userSearchModalInstance() {
      return this.$refs[this.userSearchModalKey];
    },
    userContentTypes() {
      return this.$store.getters["account/userContentTypes"];
    },
    userSavedSearches() {
      return this.$store.getters["account/userSavedSearches"];
    },
    showDelete() {
      return this.userSearch.id > 0;
    },
  },
  methods: {
    onContentTypeSelected(contentTypeIDs) {
      this.userSearch.contentTypeIDs = contentTypeIDs;
    },
    onSearchEdit(item) {
      this.userSearch = new UserSearch(item);
      this.contentTypesMultiselectInstance.setSelectedItems(
        this.userSearch.contentTypeIDs
      );
      this.$nextTick(() => {
        this.searchCriteriaBuilderInstance.edit(this.userSearch.conditionStr);
      });
    },
    onSearchSave() {
      var condition = this.searchCriteriaBuilderInstance.getConditionStr();
      if (condition == "" || condition == "INVALID") {
        return;
      }
      this.userSearch.conditionStr = condition;
      this.userSearchModalInstance.edit(this.userSearch);
    },
    onSearchDelete() {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          SearchService.deleteUserSearch(this.userSearch.id).then((result) => {
            Utils.toast.success(
              this.$t("UserSearch") + " " + this.$t("DeletedSuccessfullyFem")
            );
            this.userSearch = new UserSearch();
            this.$store.dispatch("account/getUserSavedSearches");
          });
        }
      });
    },
    advsearch() {
      var condition = this.searchCriteriaBuilderInstance.getConditionStr();
      if (condition == "" || condition == "INVALID") {
        return;
      }
      var pattern = {
        contentTypeIDs: this.userSearch.contentTypeIDs.join(","),
        searchPattern: condition,
        searchAllVersions: this.userSearch.searchAllVersions,
      };
      this.modalInstance.progress(true);
      var route = "/search/";
      route += `${SearchType.AdvancedSearch}/${encodeURIComponent(
        JSON.stringify(pattern)
      )}`;
      this.$router.push(route);
      this.modalInstance.progress(false);
      this.hide();
    },
    show() {
      this.$v.$reset();
      this.open = true;
    },
    onCancel() {
      this.clear();
      this.hide();
    },
    hide() {
      this.open = false;
      this.clear();
    },
    clear() {
      if (this.userSearch != new UserSearch()) {
        this.userSearch = new UserSearch();
        this.userSearch.contentTypeIDs = this.userContentTypes.map((x) => x.id);
        this.contentTypesMultiselectInstance.setSelectedItems(
          this.userSearch.contentTypeIDs
        );
        this.searchCriteriaBuilderInstance.reset();
      }
    },
  },
};
</script>
